import { SubscriptionStatusEnum } from "$/lib/types/models/Subscription.types";

/*
incomplete, -> erreur moyen de paiement
incomplete_expired, -> erreur de paiement
trialing, -> période d'essai
active, -> active
past_due, -> retard de paiement
canceled, -> résiliée
unpaid, -> facture impayée
paused. -> suspendue
*/
export const SubscriptionStatusMapper: Record<
  SubscriptionStatusEnum,
  { label: string; color: string; backgroundColor: string }
> = {
  [SubscriptionStatusEnum.ACTIVE]: {
    label: "Active",
    color: "#00A67E",
    backgroundColor: "#E6F9F4",
  },
  [SubscriptionStatusEnum.INCOMPLETE]: {
    label: "Erreur moyen de paiement",
    color: "#FF4B67",
    backgroundColor: "#FFE6EB",
  },
  [SubscriptionStatusEnum.INCOMPLETE_EXPIRED]: {
    label: "Erreur de paiement",
    color: "#FF4B67",
    backgroundColor: "#FFE6EB",
  },
  [SubscriptionStatusEnum.TRIALING]: {
    label: "Période d'essai",
    color: "#5E4DFF",
    backgroundColor: "#E0E0FF",
  },
  [SubscriptionStatusEnum.PAST_DUE]: {
    label: "Retard de paiement",
    color: "#FF9500",
    backgroundColor: "#FFF4E5",
  },
  [SubscriptionStatusEnum.CANCELED]: {
    label: "Résiliée",
    color: "#696680",
    backgroundColor: "#F0F0F0",
  },
  [SubscriptionStatusEnum.CANCELLING]: {
    label: "Résiliation en cours",
    color: "#FF9500",
    backgroundColor: "#FFF4E5",
  },
  [SubscriptionStatusEnum.UNPAID]: {
    label: "Facture impayée",
    color: "#FF4B67",
    backgroundColor: "#FFE6EB",
  },
  [SubscriptionStatusEnum.PAUSED]: {
    label: "Suspendue",
    color: "#696680",
    backgroundColor: "#F0F0F0",
  },
};
